/**
 * Converts query parameters to API-compatible format
 * Filters out null/undefined values and converts specific boolean/numeric fields to strings
 * @param params - Query parameters object (accepts any object-like structure)
 * @returns Converted parameters with proper string/boolean conversions compatible with Angular HttpClient
 */
export function convertQueryParamsForApi<T extends Record<string, any>>(
  params: T,
): Record<
  string,
  string | number | boolean | readonly (string | number | boolean)[]
> {
  const converted: Record<
    string,
    string | number | boolean | readonly (string | number | boolean)[]
  > = {};

  // Convert boolean values to strings for API compatibility
  const booleanFields = [
    'grid_view',
    'mtr_selection',
    'is_export',
    'is_outcome',
  ];

  // Process all params, filtering out null/undefined and converting specific fields
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null) {
      // Convert specific boolean fields to strings
      if (booleanFields.includes(key) && typeof value === 'boolean') {
        converted[key] = value.toString();
      }
      // Convert specific numeric fields to strings
      else if (
        (key === 'page' || key === 'page_size') &&
        typeof value === 'number'
      ) {
        converted[key] = value.toString();
      }
      // Keep other values as-is (string, number, boolean, or arrays)
      else if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        Array.isArray(value)
      ) {
        converted[key] = value as
          | string
          | number
          | boolean
          | readonly (string | number | boolean)[];
      }
    }
  });

  return converted;
}
